function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import { Input, Form, Button, Select, Alert, InputNumber, Modal, Switch, Radio, Drawer, Descriptions } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { GeoAltFill, QuestionCircleFill, ListTask, Clipboard2PulseFill } from 'react-bootstrap-icons';
import { Icon } from "@iconify/react";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import HospitalizationDepositReceipt from "../HospitalizationDepositReceipt";
import ExitPaper from "../ExitPaper";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var HospitalizationOut = function HospitalizationOut(_ref) {
  var handler = _ref.handler,
      _ref$hospitalization = _ref.hospitalization,
      hospitalization = _ref$hospitalization === void 0 ? null : _ref$hospitalization;

  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      companyOptions = _useState8[0],
      setCompanyOptions = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      companies = _useState10[0],
      setCompanies = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isDataChanged = _useState12[0],
      setIsDataChanged = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showExitPaper = _useState14[0],
      setShowExitPaper = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      updatedHospitalization = _useState16[0],
      setUpdatedHospitalization = _useState16[1];

  var onFinish = function onFinish(values) {
    confirm({
      type: "warning",
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La sortie du patient ", hospitalization.customer.firstname + " " + hospitalization.customer.lastname, " ?"]
      }),
      okText: "Valider",
      cancelText: "Annuler",
      onOk: function onOk() {
        executeExit(values);
      }
    });
  };

  var executeExit = function executeExit(values) {
    var formData = new FormData();
    formData.append('reason', values.reason);
    formData.append('synthesis', values.synthesis);
    formData.append('entry_mode', values.entry_mode);
    formData.append('recommandation', values.recommandation);
    formData.append('pratician_name', values.pratician_name);
    formData.append('destination', values.destination);
    formData.append("hospitalization_id", hospitalization.id);
    formData.append("user_id", Common.currentUser.id);
    setErrorMessage('');
    setSuccessMessage('');
    axios.post(Common.baseApiUrl + 'exitpatient', formData).then(function (response) {
      setIsFormLoading(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
        setUpdatedHospitalization(response.data.hospitalization);
        setShowExitPaper(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    setCompanyOptions([{
      value: 0,
      label: 'Aucune prise en charge'
    }]);
    setUpdatedHospitalization(null);
    axios.get(Common.baseApiUrl + "getcompanylist/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCompanies(response.data.companyList);
        response.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }

      form.setFieldsValue({
        gender: 'F',
        category: 0,
        company_id: 0
      });
    })["catch"](function (error) {});
  }, []);
  useEffect(function () {
    setIsDataChanged(false);
    form.setFieldsValue({
      entry_mode: 1
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      padding: "14px",
      borderRadius: "7px",
      background: "#FFFFFF"
    },
    children: [hospitalization && hospitalization.customer && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          background: "#F3F2EE",
          padding: "22px",
          borderRadius: "7px"
        },
        children: /*#__PURE__*/_jsxs(Descriptions, {
          column: 2,
          children: [/*#__PURE__*/_jsx(Descriptions.Item, {
            labelStyle: {
              fontWeight: 'Bold'
            },
            span: 2,
            contentStyle: {
              fontWeight: 'Bold'
            },
            label: "CODE PATIENT",
            children: hospitalization.customer.idnumber
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Pr\xE9nom"
            }),
            children: hospitalization.customer.firstname
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Nom"
            }),
            children: hospitalization.customer.lastname
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Tel."
            }),
            children: hospitalization.customer.mobile.toString().slice(3)
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Genre"
            }),
            children: hospitalization.customer.gender == 'F' ? "Femme" : "Homme"
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Age"
            }),
            children: hospitalization.customer.birthdate
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Profession"
            }),
            children: hospitalization.customer.job
          })]
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
        layout: "vertical",
        onFinish: onFinish,
        form: form,
        children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Alert, {
            message: errorMessage,
            type: "error",
            showIcon: true
          })
        }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Alert, {
            message: successMessage,
            type: "success",
            showIcon: true
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            lg: 12,
            md: 12,
            children: [/*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 8,
                md: 8,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "reason",
                  label: "Motif de l'hospitalisation",
                  rules: [{
                    required: true,
                    message: 'Ce champs est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {
                    prefix: /*#__PURE__*/_jsx(QuestionCircleFill, {})
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "entry_mode",
                  label: "Mode d'entr\xE9e",
                  rules: [{
                    required: true,
                    message: 'Ce champs est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Select, {
                    options: [{
                      label: "Programmé",
                      value: 0
                    }, {
                      label: "Urgence",
                      value: 1
                    }, {
                      label: "Transfert",
                      value: 2
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "synthesis",
              label: "Synth\xE8se m\xE9dicale du s\xE9jour",
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }],
              children: /*#__PURE__*/_jsx(TextArea, {
                autoSize: true,
                prefix: /*#__PURE__*/_jsx(Clipboard2PulseFill, {})
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "recommandation",
              label: "Recommandations",
              children: /*#__PURE__*/_jsx(TextArea, {
                autoSize: true,
                prefix: /*#__PURE__*/_jsx(ListTask, {})
              })
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 7,
                md: 7,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "pratician_name",
                  label: "M\xE9decin traitant",
                  rules: [{
                    required: true,
                    message: 'Ce champs est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {
                    prefix: /*#__PURE__*/_jsx(Icon, {
                      icon: "fa-solid:user-md"
                    })
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "destination",
                  label: "Destination du patient \xE0 la sortie",
                  rules: [{
                    required: true,
                    message: 'Ce champs est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {
                    prefix: /*#__PURE__*/_jsx(GeoAltFill, {})
                  })
                })
              })]
            })]
          })
        }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
          name: "submit",
          children: /*#__PURE__*/_jsx(Button, {
            loading: isFormLoading,
            htmlType: "submit",
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "Sauvegarder"
            })
          })
        })]
      })]
    }), updatedHospitalization && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Fiche de sortie"
      }),
      width: "70%",
      open: showExitPaper,
      onClose: function onClose() {
        setShowExitPaper(false);
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(ExitPaper, {
          hospitalization: updatedHospitalization
        })
      }, ref)
    })]
  });
};

export default HospitalizationOut;